import React from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../../../../redux/store";
import {
    Avatar,
    Divider,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
} from "@mui/material";
import EmptyCommandPlaceholder from "./EmptyCommandPlaceholder";
import palette from "../../../../../helpers/palette";
import Icd10Chip from "../../../../../components/Icd10Chip";

export default function () {
    const methodology = useSelector((state: RootState) => state.consultationSlice.commandResponses["METHODOLOGY"]);

    if (!methodology) return <EmptyCommandPlaceholder/>;

    const instructions = methodology.analysis.stepByStepInstructionsForMostRelevantProcedure.instructions;
    const procedureName = methodology.analysis.stepByStepInstructionsForMostRelevantProcedure.procedure.name;
    const icd10 = methodology.analysis.stepByStepInstructionsForMostRelevantProcedure.procedure.diagnosis.icd10;
    const diagnosisName = methodology.analysis.stepByStepInstructionsForMostRelevantProcedure.procedure.diagnosis.diagnosisName;

    return (
        <List style={{padding: 0}}>
            <ListItemText
                style={{padding: 10}}
                key={procedureName}
                primary={procedureName}
                secondary={
                    <span>
                        <Icd10Chip icd10={icd10}/> {diagnosisName}
                    </span>}
            />
            {instructions.map((step: string, index: number) =>
                <span key={step}>
                    <Divider/>
                    <ListItem>
                        <ListItemAvatar style={{marginRight: -20}}>
                            <Avatar style={{backgroundColor: palette.supporting2}} sx={{ width: 24, height: 24 }}>
                                {(index + 1)}
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText key={step} primary={step}/>
                    </ListItem>
                </span>
            )}
        </List>
    )
}